export default __webpack_public_path__ + "static/media/num.70ff2687.jfif";